import React, { useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { updateEventOptions } from 'gqlQueries/promoRecommendation';

const errorMessage: string = 'Something went wrong!';

function useUpdateEventOptions({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [updateEvent, { data: eventsListData, loading: eventsListDataLoading, error: eventsListDataError }] =
        useMutation(updateEventOptions, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            onComplete();
            //const featureGroup = payload;
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,

        updateEventOptions: (variables: any) => {
            setError(null);
            setLoading(true);
            updateEvent(variables);
        },
    };
}

export { useUpdateEventOptions };
